export const REMIND_SEPA_DD = gql`
    mutation remindSepaDD($id: Int!) {
        remindSepaDD(id: $id) {
            id
        }
    }
`;
